(function cloneTemplateForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderTemplateClone',
	};

	var $modal = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// toggle global/custom banner fields
		$('.image-type > .btn-radio').click(function _imageTypeClicked() {
			var data_type = $(this).data('type');

			if (data_type === 'global') {
				// global banner
				$('.global-banner').removeClass('hidden');
				$('.custom-banner').addClass('hidden');
			} else {
				// custom banner
				$('.global-banner').addClass('hidden');
				$('.custom-banner').removeClass('hidden');
			}
		});

		// custom banner
		$('.remove-banner').click(function _removeCustomBanner(e) {
			e.preventDefault();

			$('#fitbuildertemplateclone-image_name').val('');
			$('#fitbuildertemplateclone-remove_banner').val('1');
			$('.selected-banner').attr('src', '');

			$('.selected-banner-remove').addClass('hidden');
		});

		// main picture
		$('.fit-builder-template-library-select').click(function _showImagePicker(e) {
			e.preventDefault();

			showImagePicker();
		});

		$('.remove-image').click(function _removeLibraryImage(e) {
			e.preventDefault();

			$('#fitbuildertemplateclone-picture').val('');
			$('#fitbuildertemplateclone-library_image').val('');
			$('#fitbuildertemplateclone-remove_picture').val('1');
			$('.selected-image').attr('src', '');

			$('.selected-image-remove').addClass('hidden');
		});
	};

	function showImagePicker(day = null, component = null)
	{
		var $image_library_preview,
			$id_picture,
			$id_library_image,
			$id_remove_picture,
			$selected_image,
			$selected_image_remove,
			day_index,
			component_index,
			field_id;

		// change the element references based on having day/component or not
		if (day !== null && component !== null) {
			day_index              = String(day - 1);
			component_index        = String(component - 1);
			field_id               = '#fitbuildertemplateclone-days-' + day_index + '-components-' + component_index + '-';
			$image_library_preview = $('.image-library-preview[data-day="' + day + '"][data-component="' + component + '"]');
			$id_picture            = $(field_id + 'component_picture');
			$id_library_image      = $(field_id + 'component_library_image');
			$id_remove_picture     = $(field_id + 'remove_component_picture');
			$selected_image        = $('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]');
			$selected_image_remove = $('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]');
		} else {
			$image_library_preview = $('.image-library-preview');
			$id_picture            = $('#fitbuildertemplateclone-picture');
			$id_library_image      = $('#fitbuildertemplateclone-library_image');
			$id_remove_picture     = $('#fitbuildertemplateclone-remove_picture');
			$selected_image        = $('.selected-image');
			$selected_image_remove = $('.selected-image-remove');
		}

		$image_library_preview.attr('src', '');

		$modal.addClass('wide');
		$modal.find('.modal-title').text('Image Library');
		$modal.find('.modal-body').text('Loading image library...');

		Adzuki.Ajax.get('/Images/imagePicker')
		.then(function _showImagePicker(html) {
			$modal.find('.modal-body').html(html);

			Adzuki.Form.initAjaxForm('ImageSearch');
		});

		$modal.on('click', '.image-picker .select-image', function selectImage() {
			var $image = $(this).parents('.image-container').find('img'),
				$src   = $image.attr('src');

			$id_picture.val('');
			$id_library_image.val($src);
			$id_remove_picture.val('');
			$selected_image.attr('src', $src);

			$selected_image_remove.removeClass('hidden');

			$modal.modal('hide');
		});

		$modal.on('click', '.add-button-btn', function addImageButtonPressed() {
			Adzuki.CustomConfirm({
				title  : 'Add image?',
				content: 'Adding images must be done through the Image section of the web program. Clicking \'Ok\' will take you there now. Would you like to go? Please note any unsaved work may be lost.',
				confirm: function confirm() {
					document.location = Adzuki.webprogram_url + Adzuki.base_uri + '/Images/add/';
				}
			});
		});

		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal')
				  .off('click', '.image-picker .select-image');
		}).modal('show');
	}
}(jQuery, window.Adzuki || {}));
